import React from 'react';

import { MCButton, MCText, PopoverMenu, View } from 'src/components/basic';
import { popupModel } from 'src/components/complex';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import {
  scssVariables as variables,
  remCss,
  lang,
  rgba,
  scssVariables,
  upperFirstChar
} from 'src/helpers';

import LeftDetail from 'src/pages/main/Doctor/LeftDetail';
import CenterDetail from 'src/pages/main/Doctor/CenterDetail';
import RightDetail from 'src/pages/main/Doctor/RightDetail';
import AcceptDeclineForm from 'src/components/user/AcceptDeclineForm';
import ShortInfo from 'src/components/user/ShortInfo';

import { activeModel, pendingModel } from './model';
import constants from 'src/constants';
import moment from 'moment';

const userStatuses = constants.general.userStatus;

export default class Item extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expand: false
    };
  }

  openPopup = async (actionStatus, hasReason = true) => {
    pendingModel.setStateSilent({ linkAccounts: [] });

    let { item } = this.props;
    let isMoreInfo = actionStatus === userStatuses.declined && item.status !== userStatuses.pending;
    if (!isMoreInfo) pendingModel.loadLinkAccounts(item);

    popupModel.setActivePopup('accept_decline_form', {
      active: true,
      component: AcceptDeclineForm,
      props: {
        item,
        actionStatus,
        hasReason,
        model: pendingModel,
        afterApproved: () => {
          activeModel.setListStateSilent({ items: [] });
          activeModel.loadMore();
        },
        isLinkAccounts: true
      }
    });
  };

  render() {
    let { item, index } = this.props;
    return (
      <div
        className={'mc-flex-col mc-ptb15 mc-plr10 mc-mlr30 '}
        style={{
          backgroundColor:
            index % 2 === 0
              ? rgba(scssVariables['colors-mc-primary'], 0.08)
              : scssVariables['colors-mc-white']
        }}
      >
        <div className={'mc-flex'}>
          <div className={'mc-flex-col mc-grow'} style={{ minWidth: 0, position: 'relative' }}>
            <ShortInfo
              user={item}
              large
              description={item.email}
              styleName={item.status !== userStatuses.pending ? { flex: 1, maxWidth: 150 } : null}
              badges={
                item.status !== userStatuses.pending && (
                  <MCText
                    primary={item.status === userStatuses.updated}
                    secondary={item.status !== userStatuses.updated}
                    size={18}
                    label={upperFirstChar(item.status)}
                  />
                )
              }
            />
          </div>
          <div className={'mc-flex'}>
            <MCText
              style={{ textAlign: 'right', paddingRight: 30 }}
              label={moment(item.updated || item.created).calendar({
                sameDay: 'ddd MM.YYYY[\n]HH:mm',
                lastDay: 'ddd MM.YYYY[\n]HH:mm',
                lastWeek: 'ddd MM.YYYY[\n]HH:mm',
                sameElse: () => {
                  return 'DD.MM.YYYY[\n]HH:mm';
                }
              })}
            />
            <MCButton
              light
              primary
              medium
              radius
              style={{ width: remCss(123) }}
              onClick={() => this.openPopup(userStatuses.approved)}
            >
              {lang.t('Accept')}
            </MCButton>
            <MCButton
              light
              secondary
              medium
              radius
              style={{ width: remCss(123) }}
              onClick={() => this.openPopup(userStatuses.declined)}
            >
              {lang.t(item.status === userStatuses.pending ? 'Decline' : 'More info')}
            </MCButton>
            <View>
              <PopoverMenu
                placement={'bottom-end'}
                triggerOffset={0}
                menu={() => (
                  <ul
                    className={'mc-select-field-items'}
                    style={{
                      backgroundColor: 'white',
                      padding: remCss(10)
                    }}
                  >
                    <li>
                      <MCButton
                        iconname={BASE_ICONS.CLOSE}
                        width={48}
                        padding={7}
                        light
                        radius
                        secondary
                        onClick={() => this.openPopup('removed', false)}
                      />
                    </li>
                  </ul>
                )}
                className={'mc-no-style-btn'}
              >
                {() => <SVGIcon iconname={BASE_ICONS.DOTS} width={44} padding={7} />}
              </PopoverMenu>
            </View>
            <MCButton
              onClick={() => {
                this.setState({ expand: !this.state.expand });
                if (this.state.hospitals === null)
                  pendingModel.loadHospitals(this.props.id, ({ hospitals }) =>
                    this.setState({ hospitals })
                  );
              }}
              tiny
              primary
              light
              radius
            >
              <span
                className={'mc-rotate ' + (this.state.expand ? 'mc-rotate-180' : '')}
                style={{ height: remCss(44) }}
              >
                <SVGIcon
                  iconname={BASE_ICONS.DOWN}
                  width={44}
                  padding={5}
                  fill={variables['colors-mc-primary']}
                />
              </span>
            </MCButton>
          </div>
        </div>
        <div className={'mc-doctor-detail-page ' + (this.state.expand ? '' : 'mc-hide')}>
          <LeftDetail detail={item} isAdminPage={true} />
          <CenterDetail detail={item} isAdminPage={true} />
          <RightDetail detail={item} isAdminPage={true} />
        </div>
      </div>
    );
  }
}
